import { PAYMENT_METHODS_DETAILS_DICT } from '../../../Types';

export const getPaymentMethodDisplayName = (paymentMethodConfig) => {
  if (paymentMethodConfig?.is_custom_method) {
    return paymentMethodConfig.payment_method_display_name;
  }

  return PAYMENT_METHODS_DETAILS_DICT[paymentMethodConfig.payment_method]?.display_name;
};
